module.exports = __webpack_public_path__ + "se.ba0f491a71311caa76c3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/se.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/se.svg
// module chunks = styles